
// STYLES
import * as Style from "./HeaderStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

// MISC
import UsersIconSelected from "assets/HeaderIcons/UsersIconSelected.svg";
import LeftArrow from "assets/Icons/Arrow Left.svg";
import { ButtonTypes, ModalTypes } from "models/GeneralTypes/generalTypes";
import { IUserDetails } from "models/interfaces";
import { IProps } from "./HeaderModel";

// ASSETS
import LanguageIcon from "assets/Icons/LanguageIcon.svg";
import NotificationsBell from "assets/Icons/NotificationsIcon.svg";
import SettingsIcon from "assets/Icons/SettingsIcon.svg";
import MenuIcon from "assets/Icons/SideMenuButton.svg";

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { userDetails } from "slices/sessionSlice";
import { lockerFace, modalProps, toggleIsSideMenuVisible, toggleLockerFace, toggleModalState } from "slices/uiSlice";


// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import TabsComponent from "components/Tabs/Tabs";
import { useEffect, useState } from "react";

const Header = (props: IProps) => {

  // PROPS
  const { } = props;

  // CONSTANTS USING LIBRARIES
  const location = useLocation();
  const dispatch = useAppDispatch();
  const activeTab = location.pathname.replace("/", "");
  const userDetailsData = useAppSelector<IUserDetails>(userDetails);
  const modalPropsData = useAppSelector(modalProps);
  const lockerFaceData = useAppSelector<string>(lockerFace);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Helper function to check if user is "mondo"
  const isMondoUser = () => {
    const username = localStorage.getItem('username');
    return username === 'mondo';
  };

  // const lockerFaceData = useAppSelector(lockerFace)

  // CONSTANTS USING HOOKS
  const [screenWidth, setScreenWidth] = useState(0);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize(); // Apelați funcția handleResize inițial pentru a seta valoarea inițială corectă

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // REQUEST API FUNCTIONS
  // console.log("TEST lockerFaceData", lockerFaceData)
  // HANDLERS FUNCTIONS
  // const handleSelect = (face) => {
  //   console.log("TEST IN FUNCT")
  //   dispatch(handleSelectLockerFace(face))
  // }

  const handleNavigate = () => {
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.ADD_NEW_LOCKER,
      })
    );
  };

  const handleSelect = (face) => {
    dispatch(toggleLockerFace(face))
  };

  const handleNavigateBack = () => {
    navigate("/lockerList")
  };

  const handleNotificationBellClick = () => {
    if (
      modalPropsData.isVisible === true &&
      modalPropsData.type === ModalTypes.NOTIFICATION
    ) {
      dispatch(
        toggleModalState({
          isVisible: false,
        })
      );
    } else {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.NOTIFICATION,
        })
      );
    }
  };

  const handleLanguage = () => {
    if (
      modalPropsData.isVisible === true &&
      modalPropsData.type === ModalTypes.LANGUAGE
    ) {
      dispatch(
        toggleModalState({
          isVisible: false,
        })
      );
    } else {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.LANGUAGE,
        })
      );
    }
  };

  const handleSettings = () => {
    if (
      modalPropsData.isVisible === true &&
      modalPropsData.type === ModalTypes.SETTINGS
    ) {
      dispatch(
        toggleModalState({
          isVisible: false,
        })
      );
    } else {
      dispatch(
        toggleModalState({
          isVisible: true,
          type: ModalTypes.SETTINGS,
        })
      );
    }
  };

  return (
    <Style.HeaderWrapper>
      {(activeTab === "edit-locker") &&
        <Style.BackButton onClick={handleNavigateBack}>
          <Style.BackArrow
            src={LeftArrow}
          />
        </Style.BackButton>
      }
      {(activeTab.includes("lockerList/lockerDetails/")) &&
        <Style.BackButton onClick={handleNavigateBack}>
          <Style.BackArrow
            src={LeftArrow}
          />
        </Style.BackButton>
      }

      <Style.HeaderContainer activeTab={activeTab}>

        <Style.LeftSide>
          {screenWidth < 861 && <Style.MenuIcon
            src={MenuIcon}
            alt="Menu Icon"
            onClick={() => dispatch(toggleIsSideMenuVisible(true))}
          />}
          {(activeTab !== "lockerList/lockerDetails/1" &&
            screenWidth > 768) &&
            <Style.PageTitle>
              {activeTab === "push-notifications" ? "notifications" : activeTab.includes("lockerList/lockerDetails/") ? "Locker details" : activeTab}
            </Style.PageTitle>
          }
          {/* {
            activeTab.includes("lockerList/lockerDetails") &&
            <>
              <Style.ButtonContainer>
                <ButtonAtom
                  text="FRONT"
                  onClick={() => handleSelect("front")}
                  type={lockerFaceData === "front" ? ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.SECONDARY_BUTTON_INACTIVE}
                />
              </Style.ButtonContainer>
              <Style.ButtonContainer>
                <ButtonAtom
                  text="BACK"
                  onClick={() => handleSelect("back")}
                  type={lockerFaceData === "back" ? ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.SECONDARY_BUTTON_INACTIVE}
                />
              </Style.ButtonContainer>
            </>
          } */}
          {
            (activeTab === "reports" ||
              activeTab === "invoices" ||
              activeTab === "audit") &&

            <TabsComponent />

          }
          {
            activeTab === "lockerList" &&
            <Style.ButtonContainer>
              <ButtonAtom
                text={t("page.lockersList.button.title")}
                type={ButtonTypes.SECONDARY_BUTTON_DEFAULT}
                onClick={handleNavigate}
              />
            </Style.ButtonContainer>
          }
        </Style.LeftSide>


        <Style.UserInfoContainer>
          {screenWidth > 900 && <Style.UserInfoContainer>
            <Style.Icon src={UsersIconSelected} alt="" />
            <Style.UserDetails>
              <Style.UserName>
                {userDetailsData?.fullName || "User"}
              </Style.UserName>
              <Style.UserRole>
                Operator
              </Style.UserRole>
            </Style.UserDetails>
          </Style.UserInfoContainer>}
          <Style.IconsWrapper>
            <Style.Icon
              onClick={handleNotificationBellClick}
              src={NotificationsBell}
              alt=""
            />
            {!isMondoUser() && (
              <Style.Icon onClick={handleSettings} src={SettingsIcon} alt="" />
            )}
            <Style.Icon onClick={handleLanguage} src={LanguageIcon} alt="" />
          </Style.IconsWrapper>
        </Style.UserInfoContainer>

      </Style.HeaderContainer>
    </Style.HeaderWrapper>
  );
};

export default Header;
